export default __webpack_public_path__ + "static/media/agents_1.a98d53d0.png";